import { render, staticRenderFns } from "./dataPackageDetailXbk.vue?vue&type=template&id=3f3a5d8d&scoped=true"
import script from "./dataPackageDetailXbk.vue?vue&type=script&lang=js"
export * from "./dataPackageDetailXbk.vue?vue&type=script&lang=js"
import style0 from "./dataPackageDetailXbk.vue?vue&type=style&index=0&id=3f3a5d8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3a5d8d",
  null
  
)

export default component.exports